import React from 'react';
export const Footer = () => {
  return <footer className="bg-gray-800 text-white py-6" data-id="element-340">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-341">
        <div className="mb-6" data-id="element-342">
          <h3 className="font-bold text-lg mb-2" data-id="element-343">ProVitalność Sp. z o.o.</h3>
          <p data-id="element-344">ul. Nowa 15, 00-001 Warszawa</p>
          <p data-id="element-345">NIP: 123-456-789-10</p>
        </div>
        <div className="mb-6" data-id="element-346">
          <p data-id="element-347">Dostawa: 2-3 dni robocze w Polsce</p>
          <p data-id="element-348">Obsługa klienta: info@provitalnosc.pl</p>
          <p data-id="element-349">Telefon: 22 123 45 67</p>
        </div>
        <div className="text-sm text-gray-400" data-id="element-350">
          <p data-id="element-351">
            Suplement diety. Nie zastępuje zróżnicowanej diety i zdrowego trybu
            życia. Wyniki indywidualne mogą się różnić. Produkt nie jest
            przeznaczony do diagnozowania, leczenia ani zapobiegania chorobom.
          </p>
        </div>
      </div>
    </footer>;
};